<template style="z-index: 329480394823490">
  <div id="new-paint" v-show="is_open">
    <loading
      :active="false"
      :can-cancel="false"
      :is-full-page="false"
    />
    <div
      style="text-align:left; margin-top: 15px;"
    >
    <b-form-group
    >
    Edit actual object:
 
    <div style="display:flex; margin-top:16px">
      <div style="margin-top: 10px;">
        <h4> <input-color-picker
        v-model="colorPickerEdit"

      /> </h4>

      </div>
      <div style="width:300px">
        <b-form-input
        id=""
        ref=""
        v-model="objectNameEdit"
        placeholder="Enter Object Name"
      />

      </div>
      <div style="margin-top:5px; margin-left:4px">
        <b-button 
       
            variant="gradient-danger"
            class="btn-icon rounded"
            size="sm"
        
            @click="removeObject()"
          >
            <feather-icon icon="TrashIcon" />
           
      </b-button>

      </div>
    
     
     
   
   
      
    </div>
    <div style="margin-top:10px">
      <div style="font-size:15px">
      Select type
      </div >
        <v-select
              v-model="new_type"
              :options="paintTypes"
              placeholder="Type"
              :searchable="true"
              style="width: 300px; margin-left:25px;margin-right:33px;margin-top:10px;height: 2.714rem;font-size:15px"
            >
            </v-select>
      
      </div>
    <div style="margin-top:10px; margin-left:25px;">
        <div>
          <b-form-checkbox
                v-model="draw_inside"
                class="custom-control-secondary"
              >
              Draw
            </b-form-checkbox>
        </div>
        <div>
          <b-form-checkbox
                v-model="show_square"
                class="custom-control-secondary"
              >
              Square
            </b-form-checkbox>
        </div>
        
      </div>
    </b-form-group>
    <div style="justify-content:right; display: flex;">
      <b-button
        style="margin-top:10px;margin-right: 10px; display: block;"
        variant="outline-primary"
        :disabled="objectNameEdit === ''"
        @click="saveObject()"
       
      >
        Save
      </b-button>

    </div>
   

  
     
      
    </div>
  </div>
</template>
<script>
import { BButton,  BFormInput, BFormGroup, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import InputColorPicker from 'vue-native-color-picker'
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import store from '@/store/index'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import HistogramSlider from './HistogramSlider.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ToggleButton } from 'vue-js-toggle-button'
import Swal from 'sweetalert2'
import vSelect from 'vue-select'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    InputColorPicker,
    HistogramSlider,
    VueRangeSlider,
    BButton,
    Loading,
    ToggleButton,
    BFormCheckbox,
    vSelect
  },
  props: {
   
    actual_viewer_id: {
      required: true,
      type: Number,
      default: 0,
    },
    colorPicker: {
      required: true,
      type: [String],
      default: '',
    },
    objectName: {
      required: true,
      type: [String],
      default: '',
    },
    pk: {
      required: true,
      type: Number,
      default: '',
    },
    draw:{
      required: false,
      type: Number,
      default: 0,

    },
    square:{
      required: false,
      type: Number,
      default: 0,

    },
    type:{
      required: false,
      type: String,
      default: 0,

    },
    paintTypes: {
      required: true,
      type: [Array],
      default: '',
    },
    
   
  },
  data() {
    return {
      types:['news','news34'],
      isLoadingInfo: true,
      draw_inside:0,
      show_square:0,
      is_open: true,
      change_percent: false,
      newcolor: this.color,
      histogram_x: [],
      histogram_y: [],
      histogram: {},
      update: 0,
      new_type:'',
      img: '',
      isLoading: false,
      newbrightness: this.brightness,
      newcontrast: this.contrast,
      newsaturation: this.saturation,
      bgStyle: {
        backgroundColor: '#fff',
        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
      },
      tooltipStyle: {
        backgroundColor: '#666',
        borderColor: '#666',
      },
      processStyle: {
        backgroundColor: '#999',
      },
      objectNameEdit:'',
      colorPickerEdit:'',
    
    }
  },
  created() {
    this.new_type = this.type;
    if(this.draw == 1){
      this.draw_inside = true
    }
    if(this.square == 1){
      this.show_square= true
    }
    this.objectNameEdit = this.objectName
    this.colorPickerEdit = this.colorPicker

  },


  
  methods: {
    removePaintObject(){
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        console.log("result", result)
        if (result.isConfirmed) {
          this.removeObject()
        }
      })
    
      // this.$swal({
      //   title: 'Are you sure?',
      //   text: "Selected item will be deleted. You won't be able to revert this!",
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: 'YES',
      //   customClass: {
      //     confirmButton: 'btn btn-primary',
      //     cancelButton: 'btn btn-outline-danger ml-1',
      //   },
      //   buttonsStyling: false,
      // }).then(result => {
      //   if (result.value) {
      //     this.removeObject()
        
        
      //   }
      // })

    },
    closeParentSwal(){
      this.$swal.close()
   
    },
    async saveObject(){
      var square = 0
      var draw = 0
      if(this.show_square){
        var square = 1
      }
      if(this.draw_inside){
        var draw = 1
      }
      console.log("We update object with id", this.pk, this.objectNameEdit, this.colorPickerEdit)
      const { pk, objectNameEdit, colorPickerEdit, new_type } = this
      const data = {
        color: colorPickerEdit,
        name: objectNameEdit,
        square: square,
        draw: draw, 
        type: new_type
      }
       axios.put(`${url}:${port}/viewer-update-object-paints/${pk}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          this.closeParentSwal()
     
  
        }
      }).catch(err =>{
          console.log(err)
        })

    },
    async removeObject(){
      console.log("We remove object with id", this.pk)
      const { pk } = this
      axios.put(`${url}:${port}/viewer-delete-object-paints/${pk}`, JSON.stringify({}), { headers }).then(async response => {
        if (response) {
          this.closeParentSwal()
        }
      }).catch(err =>{
          console.log(err)
        })
      // axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
      //   if (response) {
      //     console.log("Updated", actual_viewer_id)
      //     document.location.reload()
  
      //   }
      // }).catch(err =>{
      //     console.log(err)
      //   })

    },
    async updatePaintList(){
      const {actual_viewer_id, paintList } = this
      const data = { paintList: JSON.stringify(paintList)}
      console.log("Updating", actual_viewer_id)
      axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          console.log("Updated", actual_viewer_id)
          document.location.reload()
  
        }
      }).catch(err =>{
          console.log(err)
        })

    },
    addObject(){
      const {actual_viewer_id, paintList, colorPicker } = this
      try{

        paintList.push({name: this.objectName,selected: false, color: colorPicker })
      }
      catch{
        paintList = []
        paintList.push({name: this.objectName,selected: false, color: colorPicker })
      }
    
      this.updatePaintList()
      this.objectName = ''
    }
    
  
  },
}
</script>
<style>
.icp__input {
    height: 20px!important;
    width: 20px!important;
    margin-right:10px;
}
.swal2-actions{
 margin: 0 10px;
  /* display: none !important;  */
}
.vue-range-slider.slider-component {
  margin-left:0px!important;
}
.sat_slider{
    margin-top: -30px!important;
    margin-bottom: 20px!important;
}
#new-paint .swal2-confirm swal2-styled{
  /* display: none; */
  
}
/* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
    background-color: dodgerblue !important;
} */

</style>
<style scoped>

h4{
    display: flex;
    align-items: flex-start;
}
#content{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: space-between;
}
#picture{
    width: 55%;
    display: flex;
    align-items: center;
}
#picture img{
    max-width: 90%;
    max-height: 365px
}
#histograms{
    width: 40%;
}



</style>
